export const routes = {
  product_boxes: 'product_boxes',
  create_new_product_box: 'create_new_product_box',
  templates: 'templates',
  create_new_template: 'create_new_template',
  help: 'help',
};
